// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__18esa","header":"Messages_header__39RaS"};